<template>
  <v-autocomplete
    outlined
    v-model="origins"
    :items="page.originList"
    :menu-props="{ maxHeight: '400', zIndex: 13 }"
    label="Origine"
    :multiple="true"
    small-chips
    deletable-chips
    :dense="false"
  ></v-autocomplete>
</template>

<script>
import { computed, onMounted, reactive, watch } from "@vue/composition-api";
import debounce from "lodash/debounce";
import isArray from "lodash/isArray";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";

export default {
  name: "OriginFilter",
  components: {},
  props: {
    dates: {
      type: Array,
      default: () => [],
    },
    site: {
      type: Number | Array,
      default: 0,
    },
    sources: {
      type: String | Array,
      default: "",
    },
  },
  setup(props, { emit }) {
    const { axiosGet } = useAxios();
    const { store } = useProxy();

    const page = reactive({
      isInitialized: false,
      originList: [],
    });

    // =>  METHODS
    const debouncedGetList = debounce(async function () {
      getList();
    }, 500);

    const getList = async () => {
      const { data } = await axiosGet("/news-radar-data/origins", {
        ...(props.sources.length > 0
          ? {
              source_ids: isArray(props.sources)
                ? props.sources.join(",")
                : props.sources,
            }
          : {}),
        ...(props.site > 0 ? { site_id: props.site } : {}),
        ...(props.dates.length === 2
          ? { start_date: props.dates[0], end_date: props.dates[1] }
          : {}),
      });

      page.originList = data;
    };

    // =>  COMPUTED
    const origins = computed({
      get: () => store.getters["newsRadar/getOrigins"],
      set: (value) => {
        store.dispatch("newsRadar/updateOrigins", value);
      },
    });

    // =>  WATCH
    watch(
      () => props.site,
      () => debouncedGetList()
    );
    watch(
      () => props.sources,
      () => debouncedGetList()
    );
    watch(
      () => props.dates,
      () => debouncedGetList()
    );

    // =>  HOOKS
    onMounted(async () => {
      await debouncedGetList();

      page.isInitialized = true;
    });

    // =>  DATA
    return {
      origins,
      page,
    };
  },
};
</script>

<style></style>
